import { Toast as BaseToast } from '@base-ui/react'
import { clsx } from 'clsx'

/**
 * Toast Portal - Renders toasts outside normal DOM hierarchy
 */
export function ToastPortal({ children }: { children: React.ReactNode }) {
  return <BaseToast.Portal>{children}</BaseToast.Portal>
}

/**
 * Toast Viewport - Container for displaying toasts
 * Positioned at top-center by default
 */
export function ToastViewport({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof BaseToast.Viewport>) {
  return (
    <BaseToast.Viewport
      className={clsx(
        'fixed top-4 left-1/2 -translate-x-1/2',
        'z-[100] flex flex-col gap-2',
        className
      )}
      {...props}
    >
      {children}
    </BaseToast.Viewport>
  )
}
